<section class="mainTopBanner section-pd">
    <div class="container">
       <div class="row">
          <div class="col-lg-12">
             <div class="topBannerWrapper">
                <div class="top-banner-left">
                    <h1 class="trinka-sub-title">Trinka 企業版</h1>
                    <h2>專為企業打造的 Trinka 整合方案
                    </h2>
                    <p>輕鬆將 Trinka 整合至您的企業工作流程，讓團隊全面運用 Trinka 的強大寫作與校正功能。
                    </p>
                    <div class="btn-group">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button">聯繫我們</button>
                        <a href="https://calendly.com/trinkaai/meet" target="_blank"  id="autoEditGetStart" class="outline-btn">預約產品演示</a>
                    </div>
                </div>
                <div class="top-banner-right">
                   <img src="/assets/images/enterprise/enterprise_banner_img.webp" width="469" height="423" alt="enterpise" priority />
                </div>
             </div>
          </div>
       </div>
    </div>
</section>

<section class="section-pd bg-light">
    <app-trusted-global-leaders [sliderData]="globalSliderData"></app-trusted-global-leaders>
</section>

<section class="section-pd list-wrapper-style-2 tailoredSolutions">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>為不同行業量身打造的專業寫作解決方案</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 協助您的團隊高效產出專業文件，同時確保內容品質與風格一致。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <h3>醫藥、生技與生命科學領域</h3>
                    <p>Trinka 的 AI 技術精通醫學與科學寫作所需的精準與專業，提供具語境與領域針對性的修正建議。
                    </p>
                    <a [routerLink]="['/enterprise/life-sciences-medicine-and-pharma']" class="text-link d-flex align-items-center mb-0">了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <h3>語言服務、出版與媒體產業</h3>
                    <p>協助團隊維持一致寫作風格、加快出版流程，提升客戶體驗。有效減少撰寫時間與成本，品質不打折。</p>
                    <a [routerLink]="['/enterprise/language-services-publishing-and-media']" class="text-link d-flex align-items-center mb-0">了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards" >
                    <h3>教育與學術機構</h3>
                    <p>Trinka 強化學術文章的語言品質，使其符合學術寫作規範與最佳實踐，為發表做好萬全準備。</p>
                    <a [routerLink]="['/enterprise/academic-institutions']"  class="text-link d-flex align-items-center mb-0">了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>K-12 教育與線上學習平台</h3>
                    <p>Trinka 的高階 AI 協助學生在寫作過程中即時學習學術寫作原則，提升語言能力與表達技巧。
                    </p>
                    <a [routerLink]="['/enterprise/k12-and-elearning']" class="text-link d-flex align-items-center mb-0">了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                </div>
            </div>

            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-1">
                    <h3>科技平台與數位產品</h3>
                    <p>可輕鬆將 Trinka 整合至您的平台，提供即時寫作協助。打造專屬解決方案，將 Trinka 的寫作建議功能嵌入您的產品中。</p>
                    <a [routerLink]="['/enterprise/technology-platforms']" class="text-link d-flex align-items-center mb-0">了解更多
                        <svg class="mb-0" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="#0000ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="enterprise-secure">
    <app-safe-secure></app-safe-secure>
</section>

<section class="wayToIntegrateTrinka section-pd">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-50 text-center">
                    <h2>三種方式，輕鬆整合 Trinka</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>協助您的團隊全面提升寫作品質。企業用戶可享不限用量與多項專屬優惠。選擇最適合您的整合方式：
                    </p>
                </div>
            </div>
        </div>
        <section class="section-pd pt-0">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <div class="integreate_img_section">
                        <div class="GetTrinkaJs_img">
                            <img  src="/assets/images/GetTrinkaJs.gif" loading="lazy" decoding="async" alt="get trinka">
                            <span class="API_bg_layer">
                                <img src="/assets/images/API_backgrond_layer.png" loading="lazy" decoding="async" alt="api">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content" id="javascript">
                        <h3>
                            <span>01</span> 插入 Trinka JS （JavaScript 簡易整合）
                        </h3>
                        <p>只需在瀏覽器或自家系統中插入一段 JavaScript 程式碼，即可為全體團隊啟用 Trinka 功能，免除複雜整合流程。</p>
                        <ul>
                            <li>
                                <h4>簡單快速整合</h4>
                                <p>插入一段 JS 程式碼即可啟用 Trinka 的即時寫作建議。</p>
                            </li>
                            <li>
                                <h4>安全無虞</h4>
                                <p>只要在瀏覽器或自家系統中加入一小段 JavaScript 程式碼，就能讓整個團隊馬上啟用 Trinka 功能，免去繁瑣的整合流程。</p>
                            </li>
                            <li>
                                <h4>無可比擬的靈活性</h4>
                                <p>整合方式輕量、穩定度高，能隨業務需求彈性調整，後續維護也不費力。</p>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd">
            <div class="row flex-row-reverse align-items-center">
                <div class="col-lg-5">
                    <div class="integreate_img_section">
                        <div class="getTrinka_API">
                            <img class="TrinkaAPI_img" src="/assets/images/TrinkaAPI_img.png" alt="trinka api">
                            <div class="API_text_section">
                                <span></span>
                                <div class="API_text_overlay"></div>
                                <img src="/assets/images/API_text.png" alt="api text">
                            </div>
                            <span class="API_bg_layer">
                                <img class="" src="/assets/images/API_backgrond_layer.png" alt="api">
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content">
                        <h3>
                            <span>02</span> 02 導入 Trinka API（產品內部整合）
                        </h3>
                        <p>想將 Trinka 無縫整合至您的產品中？Trinka 提供強大 API，輕鬆對接任何系統。</p>
                        <ul>
                            <li>
                                <h4>強大的API</h4>
                                <p>Trinka API提供容易取得的服務，您可以隨時獲得所需的幫助。
                                </p>
                            </li>
                            <li>
                                <h4>API自訂</h4>
                                <p>您的應用程式有獨特的需求嗎？Trinka API的高度可定製可以滿足您的各種要求。
                                </p>
                            </li>
                            <li>
                                <h4>無可比擬的靈活性</h4>
                                <p>Trinka功能強大的API易於使用且具有彈性，能與您的產品規模相匹配。</p>
                            </li>
                        </ul>
                        <div class="btn-group">
                            <a [routerLink]="['/enterprise/grammar-checker-api']" class="filled-btn">了解更多</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-pd pb-0">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <div class="integreate_img_section">
                        <div class="getTrinka_on_premise">
                            <img src="/assets/images/GetTrinkaOn_Premise.png" width="300" alt="trinka premise">
                            <span class="TrinkaPurpleColor"></span>
                            <span class="TrinkaredColor"></span>
                            <span class="TrinkaYellowColor"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="integreate_text_content" id="onpremise">
                        <h3>
                            <span>03</span> 獲取Trinka內部部署
                        </h3>
                        <p>處理高度敏感資料？Trinka 內部系統是您最可靠的解決方案！讓 Trinka 在您的企業基礎架構中安心運作。</p>
                        <ul>
                            <li>
                                <h4>專屬技術支援</h4>
                                <p>由專人協助與您 IT 團隊共同整合部署，無縫上線。</p>
                            </li>
                            <li>
                                <h4>安全可靠</h4>
                                <p>所有數據僅在企業內部流通，完全掌控、零風險。</p>
                            </li>
                            <li>
                                <h4>無可比擬的靈活性</h4>
                                <p>透過簡單的整合與專業支援，Trinka 能夠隨著團隊和業務的成長輕鬆擴展。</p>
                            </li>
                        </ul>
                        <div class="btn-group">
                            <a [routerLink]="['/enterprise/on-premise-grammar-checker']" class="filled-btn">Read More</a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>

<app-local-invoice></app-local-invoice>

<app-iplisting></app-iplisting>

<section class="trinka-banner section-pd-sm">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title text-center">
                    <h3 class="text-white">為您的企業取得 Trinka 整合服務</h3>
                </div>
                <div class="btn-group justify-content-center">
                    <button (click)="navigationService.goToEnterpriseForm()" class="white-btn nowrap" type="button">立即索取報價</button>
                </div>
            </div>
        </div>  
    </div>
</section>